import { isDepletedProvision } from '../shared/inventoryQuantity';

export const mergePlayVitals = (being, context) => being ? { ...being, ...(context?.vitals || {}), ...(context?.health || {}), ...(context?.mana || {}), ...(context?.skillProgression ? { skillProgression: context.skillProgression } : {}), survival: context?.survival ?? being.survival } : being;

export const applyConsumptionToInventory = (being, result) => {
  if (!being || !result?.success) return being;
  // Container summaries may contain only ID/name. The committed quantity debit
  // still identifies that provision exactly; a vessel debit uses volume instead.
  const depletedSourceId = result.amountField === 'quantity' && result.remaining === 0 ? result.itemId : null;
  const update = (items) => (Array.isArray(items) ? items : []).map(item => ({
    ...item,
    ...(item.idEntity === result.vesselFill?.containerId && Number.isFinite(result.vesselFill?.volume)
      ? { volume: result.vesselFill.volume } : {}),
    ...(item.idEntity === result.itemId ? {
      ...(['quantity', 'volume'].includes(result.amountField) && Number.isFinite(result.remaining) ? { [result.amountField]: result.remaining } : {}),
      ...(Array.isArray(item.spells) && result.spellEffects ? { spells: item.spells.map(spell => {
        const effect = result.spellEffects.find(row => String(row.idSpell) === String(spell.idSpell));
        return effect ? { ...spell, quantity: effect.remainingQuantity } : spell;
      }) } : {}),
    } : {}),
    ...(Array.isArray(item.containedItems) ? { containedItems: update(item.containedItems) } : {}),
    ...(Array.isArray(item.containsItems) ? { containsItems: update(item.containsItems) } : {}),
  })).filter(item => item.idEntity !== depletedSourceId && !isDepletedProvision(item));
  return { ...being, ownedItems: update(being.ownedItems) };
};

export const applyItemHandoffsToInventory = (being, results) => {
  if (!being || !results?.some(result => result.success)) return being;
  const holders = new Map(results.filter(result => result.success).map(result => [result.itemId, result.physicalHolderId]));
  const update = (items, inheritedHolder = null) => (Array.isArray(items) ? items : []).map(item => {
    const holder = holders.get(item.idEntity) || inheritedHolder;
    return { ...item, ...(holder ? { physicallyCarried: holder === being.idEntity, combatHeld: false, physicalState: 'carried', physicalHolderId: holder } : {}),
      ...(Array.isArray(item.containedItems) ? { containedItems: update(item.containedItems, holder) } : {}) };
  });
  return { ...being, ownedItems: update(being.ownedItems) };
};

// A routine acknowledgement can stop the clock without preventing a reply.
// Only the executions the AI actually paused (or an unscoped danger/condition)
// block the social response resolver.
export const isNpcResponseInterrupted = ({ survivalInterrupted, interruption, activityState, playerId }) => {
  if (survivalInterrupted) return true;
  if (!interruption) return false;
  if (!Array.isArray(interruption.activityIds)) return true;
  const activities = Object.values(activityState?.actorsById?.[playerId]?.activitiesById || {});
  return activities.some(activity => interruption.activityIds.includes(activity.activityId) && activity.skill?.idPrimarySkillList === 9);
};

// A transport retry must reuse the exact request and ID, including its clock.
export const sendPlayTurn = async (send, payload) => {
  try {
    return await send(payload);
  } catch (error) {
    if (error.code === 'INVALID_ACTION' || error.status >= 400) throw error;
    return send(payload);
  }
};

export const needLabel = (kind, value) => {
  const labels = kind === 'hunger' ? ['Satisfied', 'Hungry', 'Very hungry', 'Famished'] : ['Hydrated', 'Thirsty', 'Very thirsty', 'Parched'];
  return labels[value >= 100 ? 3 : value >= 75 ? 2 : value >= 50 ? 1 : 0];
};
